import * as go from 'gojs';
import { defaultAnimateOptions } from './animate-config';
import { easingMapping } from './easing';
import { registerAnimatable } from './register-animatable';
import { Animatable, AnimateOptions } from './types';

export const animate = <T extends go.GraphObject | go.Diagram, V>(
  animatable: Array<Animatable<T, V>>,
  customOptions: AnimateOptions = {},
) => {
  const options = { ...defaultAnimateOptions, ...customOptions };

  const animation = new go.Animation();
  animation.duration = options.duration;
  animation.reversible = options.reversible;
  animation.runCount = options.runCount;
  animation.easing = easingMapping[options.easing];

  animatable.forEach(registerAnimatable(animation, options));
  animation.start();

  return new Promise<void>((resolve) => {
    animation.finished = () => {
      animation.stop();
      resolve();
    };
  });
};
